module.exports = __webpack_public_path__ + "static/media/UserManual.cff5e50f.pdf";